import { render, staticRenderFns } from "./RaceClassesSetup.vue?vue&type=template&id=5df2d5c8&"
import script from "./RaceClassesSetup.vue?vue&type=script&lang=js&"
export * from "./RaceClassesSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports